/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x159ca4 from'./../../message.js';class ChannelMessage extends _0x159ca4{constructor(_0x4616a6,_0x3e0131,_0x2a90b){super(),this['type']=_0x4616a6,this['socketId']=_0x3e0131,this['data']=_0x2a90b;}['toJSON'](){return{'type':this['type'],'socketId':this['socketId'],'data':this['data']};}static['fromJSON'](_0x455e9d){return new ChannelMessage(_0x455e9d['type'],_0x455e9d['socketId'],_0x455e9d['data']);}}ChannelMessage['DESCRIPTOR_NAME']='ChannelMessage',ChannelMessage['DESCRIPTOR']={'fields':{'type':{'type':'uint32','id':0x1},'socketId':{'type':'string','id':0x2},'data':{'type':'bytes','id':0x3}}};export default ChannelMessage;